import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import '../i18n'
import '../index.css'
import { ErrorBoundary } from '@/components/error-boundary/ErrorBoundary';
import IncorporationWizardForm from '@/components/wizard-form';

const intlTelInput = document.createElement('script');
intlTelInput.src = 'https://cdn.jsdelivr.net/npm/intl-tel-input@24.3.4/build/js/intlTelInput.min.js';
document.head.appendChild(intlTelInput);

// eslint-disable-next-line react-refresh/only-export-components
const App = () => {
  const params = JSON.parse((document.getElementById('params') as HTMLInputElement)?.value || JSON.stringify({}));

  return (
    <ErrorBoundary>
      <IncorporationWizardForm initialData={params} />
    </ErrorBoundary>
  )
}

createRoot(document.getElementById('incorporation_app')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)